import { useClerk, useUser } from '@clerk/clerk-react';

export function NotProvisionedPage() {
    const { signOut } = useClerk();
    const { user } = useUser();

    return (
        <div className="min-h-screen bg-paper flex items-center justify-center p-6">
            <div className="max-w-md w-full card card-body text-center">
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-lg bg-paper-hover text-ink-muted text-xl font-bold tracking-tighter mb-4">
                    L
                </div>
                <h1 className="text-lg font-semibold text-ink tracking-tight">
                    Access not yet granted
                </h1>
                <p className="text-sm text-ink-muted mt-2 leading-relaxed">
                    Your Clerk account ({user?.primaryEmailAddress?.emailAddress}) is signed in, but hasn't been added to the Lanz CTS dispatch system yet.
                </p>
                <p className="text-sm text-ink-subtle mt-4">
                    Please contact the system owner to have your account provisioned.
                </p>
                <button
                    onClick={() => signOut()}
                    className="btn-secondary mt-6 w-full"
                >
                    Sign out
                </button>
            </div>
        </div>
    );
}
